export default {
  edit: "post:edit",
  create: "post:create",
  delete: "post:delete",
  view: "post:view",
};
